module.exports = __webpack_public_path__ + "static/1-fd45697cdaf3141db45472c7636544d0.png";